// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"single-select-group-header-label-module__AggregateLabels__lzATiKi","SanitizedHtml":"single-select-group-header-label-module__SanitizedHtml__oLGlv2V"};